import React, { useContext} from 'react';
import { useState } from 'react';
import { MenuContext } from 'src/context/MenuContext';
import Header from "src/components/common/Header";
import UserForm from "src/components/user/UserForm";
import Menu from "src/components/common/Menu";
import { useNavigate } from "react-router-dom";
import ScrollTop from 'src/components/common/ScrollTop';

export default function UserInput() {    const containerStyle = { width: "90%", margin: "0 auto" };
    const navigate = useNavigate();
    const { visibleMenu} = useContext(MenuContext);
    const [isInputScreen, setIsInputScreen] = useState(false);

    const clickUserListBtn = () => {
        navigate('/userList');
    }
    return (
        <>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <section className="container-fluid contents-top user_input">
                    <div className="text-right">
                        <button type="button" className="btn btn-default" onClick={clickUserListBtn}>
                            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                            Back to List
                        </button>
                    </div>
                    <div style={containerStyle}>
                        <h3 className="title-style01">New User Registration</h3>
                        <UserForm isInputScreen={isInputScreen} />
                    </div>
                </section>
            </div>
            <ScrollTop/>
        </>
    );
}
